import React from 'react';
import ExternalDashboard from '../components/ExternalDashboard';
import { getSiteById } from '../config/sites';

const KalapuyaHS = () => {
  const siteConfig = getSiteById('kalapuya-hs');
  return <ExternalDashboard config={siteConfig} />;
};

export default KalapuyaHS;
